module.exports = __webpack_public_path__ + "img/2.78547dba.jpg";